<template>
	<div class="popup" v-show="subfileShow" v-cloak>
		<div class="content" id="subfile">
			<div class="title">
				<span>{{$t('language.popup.subfileSelectPopup.title')}}</span>
				<div class="icon white-close dialog-close" @click="destory()"></div>
			</div>
			<div class="subfile-introduction">
				<div class="subfile-introduction-saving" :title="wholeName">{{name}}<span ref="nameSuffx" style="display:none;">...</span></div>
				<!-- <div class="subfile-introduction-size subfie-font-size">{{$t('language.common.size')}}:{{totalSize}}</div> -->
			</div>
			<div style="height: 300px;">
				<el-scrollbar style="height:100%" :class="tableData.length>10?'more_list':''">
				<el-table ref="subfileDataTable" :data="tableData" @selection-change="isSelected" style="width: 100%;font-size: 13px;">
					<el-table-column align="left" width="14" style="border-bottom: 1px solid #ffffff;"></el-table-column>
					<el-table-column type="selection" align="left" width="30"></el-table-column>
					<el-table-column prop="name" width="225" class="subfile-pointer">
						<template slot="header" slot-scope="scope">
							<div @click="sortName()">
								<span class="subfile-pointer">{{selectedName}}</span>
								<span v-if="arrowShow == 'name'">
									<i v-if="!nameSort" class="icon-util down-arrow"></i>
									<i v-if="nameSort" class="icon-util up-arrow"></i>
								</span>
							</div>
						</template>
						<template slot-scope="scope">
							<div class="small-file tr-file-position" :class="matchfileType(scope.row.name)+'-small'"></div>
							<span v-html='scope.row.nameTxt'></span>
						</template>
					</el-table-column>
					<el-table-column prop="type" width="100">
						<template slot="header" slot-scope="scope">
							<div @click="sortType()">
								<span class="subfile-pointer">{{$t('language.common.type')}}</span>
								<span v-if="arrowShow == 'type'">
									<i v-if="!typeSort" class="icon-util down-arrow"></i>
									<i v-if="typeSort" class="icon-util up-arrow"></i>
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="sizeTxt" width="100">
						<template slot="header" slot-scope="scope">
							<div @click="sortSize()">
								<span class="subfile-pointer">{{$t('language.common.size')}}</span>
								<span v-if="arrowShow == 'size'">
									<i v-if="!sizeSort" class="icon-util down-arrow"></i>
									<i v-if="sizeSort" class="icon-util up-arrow"></i>
								</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
				</el-scrollbar>
			</div>
			<div class="subfile-foot">
				<button v-loading='loading' class="foot-download" @click="download()">{{$t('language.common.ok')}}</button>
				<!-- <button class="foot-cancel" @click="destory()">{{$t('language.common.cancel')}}</button> -->
			</div>
			<transition>
				<div class="flow-sync-icon" v-if="flowShow" id='offlineFlow'>
					<div class="icon transfer-task-position cloudsync flow-sync-position"></div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import commonUtils from "@/js/workspace/common_util.js";
	import taskListUtils from "@/js/workspace/task_list_util.js";
	import remoteTaskUtils from "@/js/workspace/remote_task_util.js";
	export default {
		data: function() {
			return {
				flowShow: false,
				subfileShow: false,
				arrowShow: null,
				sizeSort: true,
				typeSort: false,
				nameSort: false,
				name: '',
				wholeName: '',
				selectedList: [],
				selectedName: "",
				loading: false,
				cloudSite: null,
				sourceId: null,
				type: null,
				totalSize: "0",
				tableData: []
			};
		},
		methods: {
			initData(data) {
				this.totalSize = 0;
				if (data) {
					this.tableData = data.array;
					this.wholeName = data.name;
					this.name = this.getShorthand(data.name, 40);
					if (this.name.length < this.wholeName.length) {
						this.$refs.nameSuffx.style.display = null;
					}
					this.type = data.type;
					this.sourceId = data.id;
					for (var i = 0; i < this.tableData.length; i++) {
						const item = this.tableData[i];
						const size = item.size;
						item.sizeTxt = commonUtils.sizeUtil(size);
						item.nameTxt = this.getShorthand(item.name, 20);
						this.totalSize = parseInt(this.totalSize) + parseInt(size);
					}
					this.bubbleSort(this.tableData, false)
					this.$refs.subfileDataTable.toggleAllSelection()
					this.totalSize = commonUtils.sizeUtil(this.totalSize)
				}
			},
			getShorthand(str, limit) {
				let count = this.moreThanCount(str);
				var realLen = str.length + count;
				if (realLen > limit) {
					let sub = str.substr(0, limit);
					let subCount = this.moreThanCount(sub);
					return str.substr(0, limit - subCount) + "...";
				}
				return str;
			},
			moreThanCount(str) {
				var count = 0;
				for (var i = 0; i < str.length; i++) {
					const success = str[i].replace(/[\u0391-\uFFE5]/g, "aa");
					if (success == "aa") {
						count++;
					}
					let isUpper = str[i].toLowerCase().charCodeAt() - 32 == str[i].charCodeAt();
					if (isUpper) {
						count = count + 0.5;
					}
				}
				return parseInt(count);
			},
			isSelected(rows) {
				this.selectedName = this.$t('language.popup.remoteTaskPopup.torrentSelected',{num:rows.length,all:this.tableData.length});
				var size = 0;
				rows.forEach(row => {
					size += parseInt(row.size);
				});
				this.totalSize = commonUtils.sizeUtil(size);
				this.selectedList = rows;
			},
			destory() {
				this.subfileShow = false;
				this.selectedList = [];
				this.total = "";
				this.totalSize = "0";
				this.tableData = [];
				this.offlineFlow = false;
				this.loading = false;
				this.flowShow = false;
			},
			sortSize() {
				this.arrowShow = "size";
				this.sizeSort = !this.sizeSort;
				if (this.tableData) {
					this.bubbleSort(this.tableData, this.sizeSort);
					this.selectedList.forEach(item => {
						this.$nextTick(() => {
							this.$refs.subfileDataTable.toggleRowSelection(item, true);
						})
					})
				}
			},
			sortName() {
				this.arrowShow = "name";
				this.nameSort = !this.nameSort;
				if (this.tableData) {
					this.nnameSort(this.tableData, this.nameSort);
					this.selectedList.forEach(item => {
						this.$nextTick(() => {
							this.$refs.subfileDataTable.toggleRowSelection(item, true);
						})
					})
				}
			},
			sortType() {
				this.arrowShow = "type";
				this.typeSort = !this.typeSort;
				if (this.tableData) {
					this.ttypeSort(this.tableData, this.typeSort);
					this.selectedList.forEach(item => {
						this.$nextTick(() => {
							this.$refs.subfileDataTable.toggleRowSelection(item, true);
						})
					})
				}
			},
			download() {
				// 防止多次点击
				if (this.loading) {
					return;
				}
				let that = this;
				//如果是离线下载且在离线下载页面，则只返回信息
				if(this.$route.name=='remoteTask'){
					this.$parent.remoteType = 2;
                    this.$parent.torrentType = this.type;
                    this.$parent.torrentId = this.sourceId;
					this.$parent.sourceItems = this.selectedList;
					this.subfileShow = false;
					return;
				}
  
				this.loading = true;
				let taskName = commonUtils.judgeRepeatTaskName(this.$store.state.taskListArr, this);
                remoteTaskUtils.init(this);
				remoteTaskUtils.torrentDownload(taskName,this.sourceId,this.type,this.selectedList,this.cloudSite,null,function(res) {
					that.loading = false;
					if(res.status == 200) {
						that.destory();
						//创建任务成功
						taskListUtils.exeSuccessEnd('offlineFlow', 'taskList', res.tasks, that);
					}
				});
			},
			initStoreCache(itemData, callback) {
				let that = this;
				let offlineList = this.$store.state.remoteTaskArr;
				if (!offlineList) {
					this.initOfflineData(function(offlineData) {
						offlineList = offlineData;
						// offlineList.unshift(itemData);
						that.$store.commit("setRemoteTaskArr", offlineList);
						callback();
					})
				} else {
					offlineList.unshift(itemData);
					this.$store.commit("setRemoteTaskArr", offlineList);
					callback();
				}
			},
			initOfflineData(callback) {
				var that = this;
				var list = [];
				var offLineData = new taskListUtils.taskListData(commonUtils.getUserToLocal().id, 3);
				this.Utils.doTasksRequest("list", offLineData).then(res => {
					if (res.status == 200) {
						var offlineTasks = res.tasks;
						offlineTasks.sort(function(a, b) {
						  return -(a.createTime - b.createTime)
						});
						callback(offlineTasks);
					} else {
						this.loading = false;
						that.$toast({
							text: res.reason,
							type: 'fail',
							idValue: "allBox"
						});
					}
				}, err => {
					that.$toast({
						text: err,
						type: 'fail',
						idValue: "allBox"
					});
				});
			},
			ttypeSort(data, downSort) {
				let that = this;
				// 忽略大小写
				data.sort(function(o, p) {
					if (downSort) {
						return that.strCompare(o.type, p.type)
					} else {
						return that.strCompare(p.type, o.type)
					}
				});
			},
			nnameSort(data, downSort) {
				let that = this;
				// 忽略大小写
				data.sort(function(o, p) {
					if (downSort) {
						return that.strCompare(o.name, p.name)
					} else {
						return that.strCompare(p.name, o.name)
					}
				});
			},
			bubbleSort(data, downSort) {
				data.sort(function(x, y) {
					if (downSort) {
						return x.size - y.size;
					} else {
						return y.size - x.size;
					}
				});
			},
			strCompare(str1, str2) {
				if (str1 != null && str2 != null) {
					let str1Array = str1.split('');
					let str2Array = str2.split('');
					let min = str1Array.length > str2Array.length ? str2Array.length : str1Array.length;
					let k = 0;
					while (k < min) {
						let a = str1Array[k].toUpperCase();
						let b = str2Array[k].toUpperCase();
						if (a != b) {
							return a.charCodeAt() - b.charCodeAt();
						}
						k++;
					}
					return str1Array.length - str2Array.length;
				}
			},
			matchfileType(fileName) {
				return commonUtils.matchfileTypes(fileName);
			},
			exeCuteFlowIcon(task) {
				let that = this;
				let dom;
				that.flowShow = true;
				this.$nextTick(function() {
					//添加数据成功
					taskListUtils.exeSuccessEnd('offlineFlow','taskList',[task],that.$parent);
				});
				// this.$nextTick(function() {
				// 	that.flowTransferIcon();
				// });
				var mc_project = that.$parent.$parent;
				$.each(mc_project.$children, function(i, item) {
					if (item.menuOptions) { //如果是left_banner组件
						dom = mc_project.$children[i];
						return;
					}
				});
				dom.taskListNumber = dom.taskListNumber + 1;
			},
			flowTransferIcon() {
				let flowIcon = document.getElementById("offlineFlow");
				let taskListIcon = document.getElementById("taskList");
				//获取传输图标应该移动的距离并设置样式
				let xPx = taskListIcon.getBoundingClientRect().left - flowIcon.getBoundingClientRect().left;
				let yPx = taskListIcon.getBoundingClientRect().bottom - flowIcon.getBoundingClientRect().bottom;
				flowIcon.style.transition = 'all 1.4s ease';
				flowIcon.style.transform = 'translate3d(' + xPx + 'px, ' + yPx + 'px, 0px) scale(1.2) scale(1)';
				setTimeout(() => {
					flowIcon.style.transition = 'none';
					flowIcon.style.transform = 'translateX(1px)';
					flowIcon.style.opacit = '0';
				}, 1500);
			},
		},
	};
</script>

<style>
	#subfile {
		width: 500px;
		/*no*/
		height: 500px;
		/*no*/
		border: none;
	}

	#banner {
		background-color: lightgray;
		color: black;
		font-weight: 700;
	}


	#uploadLoading {
		margin-top: 2px;
		/*no*/
	}

	#subfile .cell {
		padding-left: 0px !important;
		/*no*/
		line-height: 38px !important;
		/*no*/
	}

	#subfile .el-loading-spinner .path {
		stroke: #FFFFFF !important;
	}

    #subfile .more_list .el-scrollbar__thumb{
        min-height: 10%;
    }

	#subfile .el-table th>.cell {
		padding-right: 0 !important;
	}

	#subfile .el-loading-spinner .circular {
		height: 0.25rem !important;
		width: 0.25rem !important;
	}

	#subfile .el-loading-spinner {
		line-height: 0.95rem !important;
	}

	.subfile-pointer {
		cursor: pointer;
	}

	#subfile .el-loading-mask {
		background-color: rgba(81, 102, 189, 2) !important;
		z-index: 10 !important;

	}

	#subfile .el-table__header tr,
	#subfile .el-table__header th {
		padding: 0 !important;
		height: 10px !important;
		/*no*/
		border-bottom: none;
	}

	#subfile .el-checkbox:last-of-type {
		margin-right: 15px !important;
		/*no*/
	}

	#subfile .el-table__body tr,
	#subfile .el-table__body td {
		padding: 0 !important;

	}

	#subfile .el-table::before{
		height: 0;
	}

	#subfile .el-checkbox__input {
		margin-bottom: 5px;/*no*/
	}

	#subfile .el-checkbox__inner {
		width: 15px !important;
		/*no*/
		height: 14px !important;
		/*no*/
		border: 1px solid #DCDFE6 !important;
		/*no*/
		border-radius: 0px;
		/*no*/
	}

	#subfile .el-table td,
	.el-table th {
		min-width: 0 !important;
		-webkit-box-sizing: border-box !important;
		box-sizing: border-box !important;
		text-overflow: ellipsis !important;
		vertical-align: middle !important;
		position: relative !important;
		text-align: left !important;
	}
	#subfile .el-table td, .el-table th.is-leaf{
		border-bottom: 1px solid #eef1f6;/*no*/
	}
	#subfile .el-table td:first-of-type{
		border-bottom: 1px solid #ffffff;/*no*/
	}

	#subfile .el-checkbox__input.is-checked .el-checkbox__inner,
	#subfile .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #4282ff !important;
	}
	#subfile .el-table thead{
		color: #afb1b6;
	}
	#subfile .el-table{
		color: #6e7178;
	}

	#subfile .el-table__body, .el-table__footer, #subfile .el-table__header{
		padding-left: 6px;/*no*/
	}

	#subfile .el-table-column--selection .cell {
		padding-left: 0rem !important;
		padding-right: 0 !important;
		margin: 0 auto !important;
		line-height: 38px !important;
	}

	#subfile .el-checkbox__input.is-indeterminate .el-checkbox__inner::before{
		top: 5px;/*no*/
	}

	#subfile .el-checkbox__inner::after {
		-webkit-box-sizing: content-box !important;
		box-sizing: content-box !important;
		content: "" !important;
		border: 1.5px solid white !important;
		/*no*/
		border-left: 0 !important;
		border-top: 0 !important;
		height: 7.5px !important;
		/*no*/
		left: 2px !important;
		/*no*/
		margin-left: 1.5px;
		/*no*/
		position: absolute !important;
		top: 0 !important;
		width: 3px !important;
		/*no*/
		transition: transform .15s ease-in .05s, -webkit-transform .15s ease-in .05s !important;
		transform-origin: center !important;
	}

	.subfile-introduction {
		height: 50px;
		/*no*/
		margin-left: 20px;
		/*no*/
	}

	.subfile-introduction-saving {
		margin-top: 18px;
		/*no*/
		font-weight: bold;

	}

	.subfile-introduction-saving:hover {
		cursor: pointer;
	}

	.subfile-introduction-size {
		margin-top: 6px;
		/*no*/
		margin-bottom: 18px;
		/*no*/
		font-weight: 300;
		color: dimgrey;
	}

	.subfie-font-size {
		font-size: 13px;
		/*no*/
	}

	.subfie-pointer {
		cursor: pointer;
	}

	.subfile-foot {
		position: absolute;
		right: 20px;
		/*no*/
		bottom: 10px;
		/*no*/
	}

	.foot-download {
		min-width: 110px;
		/*no*/
		border-radius: 6px;
		/*no*/
	}

	.foot-cancel {
		background-color: white;
		border: 0.5px solid #5166BD;
		/*no*/
		color: #5166BD;
	}

	.foot-cancel:hover {
		color: white;
		border: 0.5px solid #3250c9;
		/*no*/
	}


	#subfile .el-table--scrollable-y .el-table__body-wrapper{
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/popup/remote_task_popups/subfile_select_popup.vue